import { render } from "./CrmDealKanbanDealDataModalReportModalHospitalComponent.vue?vue&type=template&id=3dd713b6"
import script from "./CrmDealKanbanDealDataModalReportModalHospitalComponent.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanDealDataModalReportModalHospitalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__